import { InjectionToken, NgModule } from '@angular/core';
import { PARTNER_CENTER_BILLING_CONFIG_TOKEN, PartnerCenterBillingConfig } from './config';

@NgModule({
  imports: [],
})
export class PartnerCenterBillingCoreModule {
  static forRoot(config: InjectionToken<PartnerCenterBillingConfig>) {
    return {
      ngModule: PartnerCenterBillingCoreModule,
      providers: [
        {
          provide: PARTNER_CENTER_BILLING_CONFIG_TOKEN,
          useExisting: config,
          deps: [],
        },
      ],
    };
  }
}
